import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faQuoteLeft, 
  faUserTie, 
  faClipboardList, 
  faFileAlt, 
  faCreditCard, 
  faUserCheck, 
  faGraduationCap,
  faArrowRight,
  faCheckCircle,
  faCalendarAlt,
  faPhone,
  faEnvelope,
  faBriefcase,
  faBook,
  faAward,
  faIdCard,
  faSearch,
  faFileSignature
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import InformasiSection from '../components/InformasiSection';
import '../styles/Pendaftaran.css';

const Pendaftaran = () => {
  // Data Ketua STIKES
  const ketua = {
    nama: "Drs. Yulis Tinta, M.Kes",
    jabatan: "Ketua STIKES Baramuli"
  };

  // Alur Pendaftaran Mahasiswa Baru
  const alurPMB = [
    {
      step: 1,
      icon: faClipboardList,
      title: "Registrasi Online",
      desc: "Daftar melalui website PMB dan lengkapi data diri",
      color: "#3b82f6"
    },
    {
      step: 2,
      icon: faFileAlt,
      title: "Upload Dokumen",
      desc: "Unggah berkas persyaratan (Ijazah, KTP, Pas Foto, dll)",
      color: "#8b5cf6"
    },
    {
      step: 3,
      icon: faCreditCard,
      title: "Pembayaran",
      desc: "Lakukan pembayaran biaya pendaftaran",
      color: "#ec4899"
    },
    {
      step: 4,
      icon: faSearch,
      title: "Seleksi Administrasi",
      desc: "Verifikasi berkas dan kelengkapan dokumen",
      color: "#f59e0b"
    },
    {
      step: 5,
      icon: faUserCheck,
      title: "Pengumuman",
      desc: "Cek hasil seleksi melalui website atau SMS",
      color: "#10b981"
    },
    {
      step: 6,
      icon: faGraduationCap,
      title: "Daftar Ulang",
      desc: "Registrasi ulang dan pembayaran semester pertama",
      color: "#1e3a8a"
    }
  ];

  // Alur Pendaftaran RPL (Rekognisi Pembelajaran Lampau)
  const alurRPL = [
    {
      step: 1,
      icon: faIdCard,
      title: "Registrasi Akun RPL",
      desc: "Buat akun khusus program RPL di portal pendaftaran",
      color: "#1e3a8a"
    },
    {
      step: 2,
      icon: faBriefcase,
      title: "Upload Portofolio",
      desc: "Unggah dokumen pengalaman kerja, sertifikat kompetensi, dan pelatihan",
      color: "#2563eb"
    },
    {
      step: 3,
      icon: faFileAlt,
      title: "Berkas Akademik",
      desc: "Upload ijazah terakhir, transkrip nilai, dan dokumen pendukung",
      color: "#3b82f6"
    },
    {
      step: 4,
      icon: faBook,
      title: "Asesmen Mandiri",
      desc: "Isi form asesmen mandiri untuk pemetaan kompetensi",
      color: "#8b5cf6"
    },
    {
      step: 5,
      icon: faSearch,
      title: "Verifikasi Asesor",
      desc: "Tim asesor memverifikasi dan menilai portofolio",
      color: "#ec4899"
    },
    {
      step: 6,
      icon: faAward,
      title: "Hasil Pengakuan SKS",
      desc: "Pengumuman jumlah SKS yang diakui dari pengalaman",
      color: "#f59e0b"
    },
    {
      step: 7,
      icon: faFileSignature,
      title: "Penandatanganan Kontrak",
      desc: "Tandatangan perjanjian dan rencana studi",
      color: "#10b981"
    },
    {
      step: 8,
      icon: faGraduationCap,
      title: "Mulai Perkuliahan",
      desc: "Ikuti perkuliahan sesuai mata kuliah yang belum diakui",
      color: "#059669"
    }
  ];

  // Persyaratan Pendaftaran
  const persyaratanPMB = [
    "Fotokopi Ijazah SMA/SMK/MA legalisir (2 lembar)",
    "Fotokopi SKHUN legalisir (2 lembar)",
    "Fotokopi Kartu Keluarga",
    "Fotokopi KTP",
    "Pas Foto 3x4 dan 4x6 (masing-masing 4 lembar)",
    "Surat Keterangan Sehat dari dokter",
    "Surat Keterangan Bebas Narkoba",
    "Mengisi formulir pendaftaran online"
  ];

  const persyaratanRPL = [
    "Fotokopi Ijazah D3 Keperawatan/Kesehatan legalisir",
    "Fotokopi Transkrip Nilai legalisir",
    "Surat Keterangan Kerja minimal 2 tahun",
    "Fotokopi STR (Surat Tanda Registrasi) yang masih berlaku",
    "Sertifikat pelatihan dan workshop yang relevan",
    "Portofolio pengalaman kerja",
    "Surat Rekomendasi dari tempat kerja",
    "Pas Foto 3x4 dan 4x6 (masing-masing 4 lembar)"
  ];

  return (
    <main className="pendaftaran-page">
      {/* Hero Section */}
      <section className="pendaftaran-hero">
        <div className="pendaftaran-hero-overlay"></div>
        <div className="container">
          <h1>Pendaftaran Mahasiswa Baru</h1>
          <p>Bergabunglah bersama kami untuk menjadi tenaga kesehatan profesional</p>
          <div className="hero-badges">
            <span className="hero-badge">Tahun Akademik 2026/2027</span>
            <span className="hero-badge">Pendaftaran Dibuka!</span>
          </div>
        </div>
      </section>

      {/* Sambutan Ketua Section */}
      <section className="sambutan-section section">
        <div className="container">
          <div className="sambutan-card">
            <div className="sambutan-avatar">
              <div className="avatar-circle">
                <FontAwesomeIcon icon={faUserTie} />
              </div>
              <div className="avatar-info">
                <h3>{ketua.nama}</h3>
                <span>{ketua.jabatan}</span>
              </div>
            </div>
            <div className="sambutan-content">
              <FontAwesomeIcon icon={faQuoteLeft} className="quote-icon" />
              <div className="sambutan-text">
                <p>
                  <strong>Assalamu'alaikum Warahmatullahi Wabarakatuh,</strong>
                </p>
                <p>
                  Selamat datang calon mahasiswa baru STIKES Baramuli! Saya mengucapkan 
                  selamat atas keputusan Anda untuk melanjutkan pendidikan di bidang kesehatan. 
                  Pilihan yang tepat untuk masa depan yang cerah.
                </p>
                <p>
                  STIKES Baramuli berkomitmen untuk menghasilkan lulusan yang tidak hanya 
                  kompeten dalam bidang ilmu kesehatan, tetapi juga memiliki karakter yang 
                  kuat, berakhlak mulia, dan siap mengabdi kepada masyarakat. Dengan 
                  dukungan dosen berpengalaman, fasilitas modern, dan kurikulum berbasis 
                  kompetensi, kami yakin dapat membantu Anda mencapai cita-cita.
                </p>
                <p>
                  Bagi Anda yang sudah bekerja di bidang kesehatan, kami juga menyediakan 
                  program <strong>Rekognisi Pembelajaran Lampau (RPL)</strong> yang memungkinkan 
                  pengakuan atas pengalaman dan kompetensi yang telah Anda miliki. 
                  Mari bergabung dan wujudkan impian Anda bersama kami!
                </p>
                <p className="sambutan-closing">
                  <em>Wassalamu'alaikum Warahmatullahi Wabarakatuh</em>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Alur Pendaftaran PMB Section */}
      <section className="alur-section section">
        <div className="container">
          <div className="section-title">
            <h2>Alur Pendaftaran Mahasiswa Baru</h2>
            <p>Ikuti langkah-langkah berikut untuk mendaftar sebagai calon mahasiswa baru</p>
          </div>

          <div className="alur-flow">
            {alurPMB.map((item, index) => (
              <React.Fragment key={item.step}>
                <div className="alur-step">
                  <div className="step-icon" style={{ background: item.color }}>
                    <FontAwesomeIcon icon={item.icon} />
                    <span className="step-number">{item.step}</span>
                  </div>
                  <div className="step-content">
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
                {index < alurPMB.length - 1 && (
                  <div className="alur-connector">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Persyaratan PMB */}
          <div className="persyaratan-card">
            <h3>Persyaratan Pendaftaran</h3>
            <div className="persyaratan-grid">
              {persyaratanPMB.map((item, index) => (
                <div key={index} className="persyaratan-item">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="alur-cta">
            <a href="https://pmb.stikesbaramuli.ac.id" className="btn btn-accent btn-lg" target="_blank" rel="noopener noreferrer">
              Daftar Sekarang
            </a>
          </div>
        </div>
      </section>

      {/* Alur Pendaftaran RPL Section */}
      <section className="alur-section alur-rpl section">
        <div className="container">
          <div className="section-title">
            <span className="section-badge">Program Khusus</span>
            <h2>Alur Pendaftaran Rekognisi Pembelajaran Lampau (RPL)</h2>
            <p>
              Program RPL ditujukan bagi tenaga kesehatan yang sudah bekerja dan ingin 
              melanjutkan pendidikan dengan pengakuan kompetensi yang sudah dimiliki
            </p>
          </div>

          <div className="alur-rpl-flow">
            {alurRPL.map((item, index) => (
              <div key={item.step} className="alur-rpl-step">
                <div className="rpl-step-header">
                  <div className="rpl-step-icon" style={{ background: item.color }}>
                    <FontAwesomeIcon icon={item.icon} />
                  </div>
                  <div className="rpl-step-number">{item.step}</div>
                </div>
                <div className="rpl-step-content">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
                {index < alurRPL.length - 1 && (
                  <div className="rpl-connector"></div>
                )}
              </div>
            ))}
          </div>

          {/* Persyaratan RPL */}
          <div className="persyaratan-card persyaratan-rpl">
            <h3>Persyaratan Program RPL</h3>
            <div className="persyaratan-grid">
              {persyaratanRPL.map((item, index) => (
                <div key={index} className="persyaratan-item">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="alur-cta">
            <a href="https://adminrpl.stikesbaramuli.ac.id" className="btn btn-accent btn-lg" target="_blank" rel="noopener noreferrer">
              Daftar Sekarang
            </a>
          </div>
        </div>
      </section>

      {/* Jadwal & Biaya Section */}
      <section className="jadwal-section section">
        <div className="container">
          <div className="jadwal-grid">
            <div className="jadwal-card">
              <div className="jadwal-icon">
                <FontAwesomeIcon icon={faCalendarAlt} />
              </div>
              <h3>Jadwal Pendaftaran PMB</h3>
              <ul>
                <li>
                  <strong>Gelombang 1:</strong>
                  <span>Januari - Maret 2026</span>
                </li>
                <li>
                  <strong>Gelombang 2:</strong>
                  <span>April - Juni 2026</span>
                </li>
                <li>
                  <strong>Gelombang 3:</strong>
                  <span>Juli - Agustus 2026</span>
                </li>
              </ul>
            </div>
            <div className="jadwal-card jadwal-rpl">
              <div className="jadwal-icon">
                <FontAwesomeIcon icon={faCalendarAlt} />
              </div>
              <h3>Jadwal Pendaftaran RPL</h3>
              <ul>
                <li>
                  <strong>Gelombang 1:</strong>
                  <span>Februari - April 2026</span>
                </li>
                <li>
                  <strong>Gelombang 2:</strong>
                  <span>Mei - Juli 2026</span>
                </li>
              </ul>
              <p className="jadwal-note">*Khusus tenaga kesehatan dengan pengalaman kerja minimal 2 tahun</p>
            </div>
            {/* Biaya Pendaftaran - Commented Out
            <div className="jadwal-card biaya-card">
              <div className="jadwal-icon">
                <FontAwesomeIcon icon={faCreditCard} />
              </div>
              <h3>Biaya Pendaftaran</h3>
              <div className="biaya-info">
                <div className="biaya-item">
                  <span>Mahasiswa Baru (PMB)</span>
                  <strong>Rp 300.000</strong>
                </div>
                <div className="biaya-item">
                  <span>Program RPL</span>
                  <strong>Rp 500.000</strong>
                </div>
              </div>
              <p className="biaya-note">*Biaya pendaftaran tidak dapat dikembalikan</p>
            </div>
            */}
          </div>
        </div>
      </section>

      {/* Informasi PMB Section */}
      <InformasiSection 
        kategori={null} 
        limit={6} 
        title="Informasi Pendaftaran"
        subtitle="Info terbaru seputar penerimaan mahasiswa baru dan program RPL"
      />

      {/* CTA Section */}
      <section className="pendaftaran-cta section">
        <div className="container">
          <div className="cta-content">
            <h2>Siap Mendaftar?</h2>
            <p>Hubungi kami untuk informasi lebih lanjut atau langsung daftar online</p>
            <div className="cta-buttons">
              <a href="https://pmb.stikesbaramuli.ac.id" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                Daftar Online Sekarang
              </a>
              <a href="https://wa.me/6285824871455" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} /> Chat WhatsApp
              </a>
            </div>
            <div className="cta-contact">
              <div className="contact-item">
                <FontAwesomeIcon icon={faPhone} />
                <span>0858-2487-1455</span>
              </div>
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <span>pmb@stikesbaramuli.ac.id</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Pendaftaran;
